// extracted by mini-css-extract-plugin
export default {"replybtn":"Reply_replybtn__o5wl3"};